/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TracingContactDetailsDtoAssessmentStatus =
  | (typeof TracingContactDetailsDtoAssessmentStatus)[keyof typeof TracingContactDetailsDtoAssessmentStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TracingContactDetailsDtoAssessmentStatus = {
  PENDING: 'PENDING',
  NOT_NEEDED: 'NOT_NEEDED',
  WAITING_PERIOD: 'WAITING_PERIOD',
  APPOINTMENT_VISIT: 'APPOINTMENT_VISIT',
  RESULT_INDETERMINATE: 'RESULT_INDETERMINATE',
  RESULT_NEGATIVE: 'RESULT_NEGATIVE',
  RESULT_POSITIVE: 'RESULT_POSITIVE',
  NO_UU_NEEDED: 'NO_UU_NEEDED',
  RESULT_INFECTED: 'RESULT_INFECTED',
  RESULT_NOT_INFECTED: 'RESULT_NOT_INFECTED',
  RESULT_SICK: 'RESULT_SICK',
  NOT_SHOW_UP: 'NOT_SHOW_UP',
  REFUSED_TEST: 'REFUSED_TEST',
  GONE_HIDING: 'GONE_HIDING',
  STATUS_AFTER_TB: 'STATUS_AFTER_TB',
  STATUS_AFTER_TBI: 'STATUS_AFTER_TBI',
  INCUBATION_PERIOD: 'INCUBATION_PERIOD',
} as const;
